import { createFileRoute } from '@tanstack/react-router'
import { AdminPage } from '../components/pages'
import { noIndexRouteHead } from '../lib/seo'

export const Route = createFileRoute('/de/admin/')({
  head: () => noIndexRouteHead('admin', 'de'),
  component: AdminPage,
})
